import api from 'api'

export function uploadCredential(
  userId: string,
  file: File,
  credentialType: string,
  workerRequirementId?: string,
  expiresAt?: string
) {
  const formData = new FormData()
  formData.append('document_0', file, 'credential.jpg')
  formData.append('credential', credentialType)

  if (workerRequirementId) {
    formData.append('worker_requirement_id', workerRequirementId)
  }

  if (expiresAt) {
    formData.append('document_expires_at', expiresAt)
  }

  return api.post(
    `/admin/credentials/user/upload_and_approve/${userId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}
